import { storage } from "./storage.js";

interface DeviceTokenPayload {
  device_token: string;
  screen_id: string;
  workspace_id: string;
  paired_at: string; // ISO timestamp
}

const KEY = "device_token";

export const tokenManager = {
  get(): DeviceTokenPayload | null {
    return storage.getJSON<DeviceTokenPayload>(KEY);
  },
  set(payload: DeviceTokenPayload): void {
    storage.setJSON(KEY, payload);
  },
  clear(): void {
    storage.remove(KEY);
  },
  isPaired(): boolean {
    return this.get() !== null;
  },
};

export type { DeviceTokenPayload };
